import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import useAuthState from "../../hooks/authHooks";
import ButtonSpinner from "../../utilities/ButtonSpinner";

function Login() {
  const { auth, login } = useAuthState();

  const [loginForm, setLoginForm] = useState({ username: "", password: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      username: loginForm.username,
      password: loginForm.password,
    };
    login(payload);
  };

  const handleChange = (e) => {
    setLoginForm({ ...loginForm, [e.target.name]: e.target.value });
  };
  if (auth.isAuthenticated) {
    return <Navigate to="/events" />;
  }
  return (
    <div className="flex justify-center items-center mt-14">
      <div>
        <h2 className="text-xl font-semibold mb-7">Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="flex flex-col">
            <label htmlFor="username" className="mb-1">
              Username
            </label>
            <input
              className="border border-gray-70 rounded-md outline-none h-9 w-72 p-2"
              type="text"
              id="username"
              name="username"
              value={loginForm.username}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col mt-3">
            <label htmlFor="password" className="mb-1">
              Password
            </label>
            <input
              className="border border-gray-70 rounded-md outline-none h-9 w-72 p-2"
              id="password"
              type="password"
              name="password"
              value={loginForm.password}
              onChange={handleChange}
            />
          </div>
          <button
            disabled={auth.isSubmitting ? true : false}
            type="submit"
            className={`bg-green-50 text-white p-2 flex items-center justify-center rounded-lg mt-4 w-44 h-12 hover:bg-opacity-70 ${
              auth.isSubmitting ? "bg-opacity-70" : ""
            }`}
          >
            {auth.isSubmitting ? <ButtonSpinner /> : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
